<button
  mat-stroked-button
  class="toggle-buttons__button toggle-buttons__button-true"
  [class.active]="value === true"
  (click)="toggle(true)"
  [disabled]="disabled"
  data-cy="toggle-true">
  <span class="toggle-buttons__button-label">{{ trueLabel }}</span>
  <mat-icon
    class="small-icon toggle-buttons__button-icon available"
    svgIcon="check"></mat-icon>
</button>
<button
  mat-stroked-button
  class="toggle-buttons__button toggle-buttons__button-false"
  [class.active]="value === false"
  (click)="toggle(false)"
  [disabled]="disabled"
  data-cy="toggle-false">
  <span class="toggle-buttons__button-label">{{ falseLabel }}</span>
  <mat-icon
    class="small-icon toggle-buttons__button-icon unavailable"
    svgIcon="close"></mat-icon>
</button>
